import { render, staticRenderFns } from "./SitchLanguageSelect.vue?vue&type=template&id=73815a95&scoped=true&"
import script from "./SitchLanguageSelect.vue?vue&type=script&lang=ts&"
export * from "./SitchLanguageSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73815a95",
  null
  
)

export default component.exports